import { useTranslation } from 'react-i18next';

import { Box, SvgIcon, Typography, useMediaQuery } from '@frontierag/frontier-ui-library';
import { MAX_CONTENT_WIDTH } from 'appConstants';
import Tractor from 'images/tractor.svg?react';
import { AccordionTable, Table } from 'shared';

import { styles } from './styles';
import type { IFailedOrdersTable } from './types';

export default function FailedOrdersTable({
  transNamespace,
  rows,
  columns,
  collapsibleTableData,
  noOrdersFound = false,
  accordionCells,
}: IFailedOrdersTable) {
  const { t } = useTranslation(transNamespace);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const { fixedCells, dynamicCells, actionCells, accordionSx, accordionChildren } = accordionCells;

  return (
    <>
      {!isMobile && (
        <Table
          rows={rows}
          columns={columns}
          displayNoRecords={false}
          collapsibleTableData={collapsibleTableData}
          sx={styles.failedOrdersTable}
        />
      )}
      {isMobile && (
        <Box width={MAX_CONTENT_WIDTH} margin="auto">
          <AccordionTable
            data={rows}
            keyAccessor={'internalOrderId'}
            fixedCells={fixedCells}
            dynamicCells={dynamicCells}
            actionCells={actionCells}
            defaultExpanded={false}
            sx={accordionSx}
            accordionChildren={accordionChildren}
          />
        </Box>
      )}

      {noOrdersFound && (
        <Box display="flex" alignItems="center" flexDirection="column" mt={5}>
          <SvgIcon
            component={Tractor}
            inheritViewBox={true}
            sx={{ width: 64, height: 64, mb: 3, color: 'grey.L30' }}
          />

          <Typography variant="body2">{t('emptyOrdersListTable')}</Typography>
        </Box>
      )}
    </>
  );
}
